module.exports = __webpack_public_path__ + "static/media/ulta.5d498975.png";